export default {
    age: 'Age',
    '18-22': '18-22',
    '23-27': '23-27',
    '28-32': '28-32',
    '33-37': '33-37',
    '38-42': '38-42',
    '43-47': '43-47',
    '48-52': '48-52',
    '53+': '53+',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    contactWays: 'Contact Ways',
    whatsapp: 'Whatsapp',
    email: 'Email',
    facebook: 'Facebook',
    website: 'Website',
    country: 'Residential country',
    lebanon: 'Lebanon',
    egypt: 'Egypt',
    iraq: 'Iraq',
    syria: 'Syria',
    'saudi arabia': 'Saudi Arabia',
    uae: 'UAE',
    qatar: 'Qatar',
    bahrain: 'Bahrain',
    kuwait: 'Kuwait',
    yemen: 'Yemen',
    oman: 'Oman',
    jordan: 'Jordan',
    palestine: 'Palestine',
    morocco: 'Morocco',
    tunisia: 'Tunisia',
    algeria: 'Algeria',
    libya: 'Libya',
    sudan: 'Sudan',
    mauritania: 'Mauritania',
    usa: 'USA',
    canada: 'Canada',
    australia: 'Australia',
    russia: 'Russia',
    'european country': 'European Country',
    'asian country': 'Asian Country',
    'south america': 'South American Country',
    'other country': 'Other Country',
    educationalLevel: 'Educational Level',
    none: 'None',
    school: 'School',
    university: 'University Degree',
    postgraduate: 'Post-Graduate Degree',
    other: 'Other',
    height: 'Height',
    short: 'Short',
    average: 'Average',
    tall: 'Tall',
    undefined: 'Undefined',
    job: 'Job',
    student: 'Student',
    'private employee': 'Private Employee',
    'public sector': 'Public Sector',
    finance: 'Finance',
    teaching: 'Teaching',
    medicine: 'Medicine',
    jounalist: 'Journalist',
    business: 'Business',
    commerce: 'Commerce',
    unemployed: 'Unemployed',
    pension: 'Pension',
    military: 'Military',
    kids: 'Do u have any kids?',
    yes: 'Yes',
    no: 'No',
    maritalStatus: 'Marital status',
    married: 'Married',
    single: 'Single',
    divorced: 'Divorced',
    widowed: 'Widowed',
    originCountry: 'Origin country',
    purpose: 'Purpose',
    'normal marriage': 'Normal Marriage',
    'mesyar marriage': 'Mesyar Marriage',
    polygamy: 'Polygamy',
    'new contacts': 'New Contacts',
    'internet friends': 'Internet Friends',
    'share stories': 'Share Stories',
    'meet new people': 'Meet New People',
    'meet new culture': 'Meet New Culture',
    eyeColor: 'Eye color',
    skinColor: 'Skin color',
    hairColor: 'Hair color',
    black: 'black',
    blue: 'blue',
    green: 'green',
    white: 'white',
    brown: 'brown',
    'dark brown': 'dark brown',
    'light brown': 'light brown',
    blonde: 'blonde',
    olive: 'olive',
    yellow: 'yellow',
    hazel: 'hazel',
    red: 'red',
    gray: 'gray',
    ginger: 'ginger',
    weight: 'Weight',
    light: 'Light',
    medium: 'Medium',
    chubby: 'Chubby',
    clear: 'clear'
}
